import React, { Component } from 'react'
import { Row, Col } from 'hljd'

export default class extends Component {
  render() {
    const { label, required, children } = this.props
    return (
      <Row
        style={{
          width: '100%',
          // marginBottom: 32,
          color: '#333333'
        }}
      >
        <Col xs={24} sm={4} style={{ textAlign: 'right', paddingRight: 16 }}>
          {required && <span style={{ color: 'red' }}>*</span>}
          {label}
        </Col>
        <Col xs={24} sm={18}>
          <div style={{ width: 714 }}>{children}</div>
        </Col>
      </Row>
    )
  }
}
